export const buildingEngineeringAndMaintenanceConst = {
  path: "/single-programs/building-engineering-and-maintenance",
  title: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – ИНЖЕНЕРИЯ И ЭКСПЛУАТАЦИЯ ЗДАНИЙ И СООРУЖЕНИЙ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения:</strong> очно или дистанционно
      </p>
      <p>
        <strong>Форма связи:</strong> Получить консультацию приемной комиссии
      </p>
      <h2>Инженерия и эксплуатация — надежность в каждый день</h2>
      <p>
        Эта программа готовит специалистов, отвечающих за бесперебойную и безопасную работу зданий и инженерных систем. Вы научитесь
        контролировать техническое состояние объектов, организовывать их обслуживание, разрабатывать проекты модернизации и следить за
        соблюдением нормативов.
      </p>
      <p>Программа особенно актуальна в условиях роста числа современных и энергоэффективных зданий в Европе.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Инженерные системы зданий (отопление, вентиляция, водоснабжение, электрика)</li>
        <li>Основы строительной физики</li>
        <li>Автоматизация и интеллектуальные системы управления</li>
        <li>Эксплуатация и диагностика конструкций</li>
        <li>Энергоэффективные технологии</li>
        <li>Планирование технического обслуживания</li>
        <li>Менеджмент недвижимости</li>
        <li>Нормативы и стандарты ЕС по эксплуатации</li>
      </ul>
      <p>
        Программа включает как теоретические занятия, так и практические кейсы, работу с инженерными платформами и моделирование ситуаций
        эксплуатации.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-эксплуатационник</li>
        <li>Специалист по обслуживанию инженерных систем</li>
        <li>Технический директор объекта</li>
        <li>Консультант по энергоэффективности</li>
        <li>Специалист по BIM-моделям и автоматизации процессов</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€45,000 до €80,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, востребованный на рынке</li>
        <li>Возможность дистанционного или очного обучения</li>
        <li>Современные симуляторы и цифровые платформы</li>
        <li>Обучение на русском или английском языке</li>
        <li>Стажировки в управляющих компаниях и инжиниринговых фирмах</li>
        <li>Поддержка и консультации от преподавателей и приемной комиссии</li>
      </ul>
      <p>Профессия, которая держит здание в рабочем состоянии</p>
      <p>
        Наши выпускники управляют крупными коммерческими и жилыми объектами, внедряют инновационные системы контроля и снижают издержки
        эксплуатации.
      </p>
      <br />
      <p className="padding-left">
        «Инженер эксплуатации — это человек, благодаря которому всё работает. Мы обучаем делать это качественно и профессионально.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам на всех этапах: от выбора программы до подачи документов.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Инженерия и эксплуатация — надежность в каждый день
    Эта программа готовит специалистов, отвечающих за бесперебойную и безопасную работу зданий и инженерных систем. Вы научитесь контролировать техническое состояние объектов, организовывать их обслуживание, разрабатывать проекты модернизации и следить за соблюдением нормативов.
    Программа особенно актуальна в условиях роста числа современных и энергоэффективных зданий в Европе.
    Что вы будете изучать?
    • Инженерные системы зданий (отопление, вентиляция, водоснабжение, электрика)
    • Основы строительной физики
    • Автоматизация и интеллектуальные системы управления
    • Эксплуатация и диагностика конструкций
    • Энергоэффективные технологии
    • Планирование технического обслуживания
    • Менеджмент недвижимости
    • Нормативы и стандарты ЕС по эксплуатации
    Программа включает как теоретические занятия, так и практические кейсы, работу с инженерными платформами и моделирование ситуаций эксплуатации.
    Кем можно работать после окончания?
    • Инженер-эксплуатационник
    • Специалист по обслуживанию инженерных систем
    • Технический директор объекта
    • Консультант по энергоэффективности
    • Специалист по BIM-моделям и автоматизации процессов
    Зарплата в Европе: от €45,000 до €80,000 в год
    Почему выбирают нас?
    • Европейский диплом, востребованный на рынке
    • Возможность дистанционного или очного обучения
    • Современные симуляторы и цифровые платформы
    • Обучение на русском или английском языке
    • Стажировки в управляющих компаниях и инжиниринговых фирмах
    • Поддержка и консультации от преподавателей и приемной комиссии
    Профессия, которая держит здание в рабочем состоянии
    Наши выпускники управляют крупными коммерческими и жилыми объектами, внедряют инновационные системы контроля и снижают издержки эксплуатации.
    «Инженер эксплуатации — это человек, благодаря которому всё работает. Мы обучаем делать это качественно и профессионально.»

    Как поступить?
    Приёмная комиссия поможет вам на всех этапах: от выбора программы до подачи документов.
`,
};
